import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createJazelVuetify } from '@jazel/jazel-vuetify'

export default createJazelVuetify({
  appClass: 'jzl-admin ai-vdg',
  theme: {
    colors: {
      primary: '#2563EB',
      success: '#10B981',
      warning: '#F59E0B',
      error: '#EF4444',
      info: '#0891B2',
      background: '#FAFAFA',
      surface: '#FFFFFF',
    },
    variables: {
      'border-opacity': 0.08,
      'hover-opacity': 0.06,
      'activated-opacity': 0.1,
      'focus-opacity': 1,
    },
  },
})
